import { useState } from "react";
import { Button, Input, Modal, Form, Select } from "antd";
import { useGetLocationsQuery } from "../../redux/services/locationsApi";
import { CheckBoxInput } from "../Booking/common/FormsElements";
import { chargerTypeOptions } from "../../constants/helperConstants";

const { Option } = Select;

const AddModelInBrandModal = (props: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { isModalOpen, brand, onCancel, addModel, selectedModel, onUpdateModel, isEditMode } = props;

  form.setFieldValue("brand_id", brand?.id);
  form.setFieldValue("brand_name", brand?.name);
  form.setFieldsValue(selectedModel);

  const { data, error, isLoading } = useGetLocationsQuery({all_pages: true});
  const locations: any = data?.locations || [];

  const handleOk = () => {
    // setIsModalOpen(false);
  };

  const onFinish = (values: any) => {
    if (Object.keys(selectedModel).length === 0) {
      const params = { brandId: brand?.id, modelData: { model: values } };
      addModel(params, setLoading, form);
    } else {
      const params = { brandId: brand?.id, modelData: { model: values }, id: selectedModel?.id };
      onUpdateModel(params, setLoading, form);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      title={isEditMode ? "Update Model" : "Add Model"}
      open={isModalOpen}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      footer={false}
    >
      <Form
        name="model_form"
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item name="brand_name" label="Brand Name">
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="name"
          label="Name"
          rules={[
            { required: true, message: "Please input name" },
            { min: 3, message: "Name must be minimum 3 characters." },
            { max: 30, message: "Name must be maximum 30 characters." }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Code"
          name="code"
          rules={[
            { required: true, message: "Please input code" },
            { min: 2, message: "Code must be minimum 2 characters." },
            { max: 10, message: "Code must be maximum 10 characters." }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Please select status" }]}
        >
          <Select
            placeholder="Select status"
            optionFilterProp="children"
            showSearch
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="active">Active</Option>
            <Option value="inactive">Inactive</Option>
            <Option value="disabled">Disabled</Option>
          </Select>
        </Form.Item>

        <Form.Item name="charger_size" label="Charger Type">
          <Select
            placeholder="Select charger type"
            showSearch
            optionFilterProp="children"
            options={chargerTypeOptions}
            filterOption={(inputValue, option: any) =>
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            }
          >
          </Select>
        </Form.Item>

        <CheckBoxInput
          label="Is this model required in payment tracker ?"
          name="is_required_in_payment_tracker"
        />

        <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {isEditMode ? "Update" : "Add"}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddModelInBrandModal;
